@if (password) {
  <div class="flex items-center justify-between">
    <!-- Password Strength Text -->
    @if (showText) {
      <div class="flex items-center justify-between">
        <h4 [class]="getPasswordStrengthColor()">{{ getPasswordStrengthText() }}</h4>
      </div>
    }

    <!-- Password Strength Indicator -->
    @if (showIndicator) {
      <div class="flex gap-2">
        <!-- Weak Step -->
        <div
          class="h-2 w-10 rounded-md transition-all duration-300"
          [class]="
            getPasswordStrength() === 'weak'
              ? 'bg-signal-error'
              : getPasswordStrength() === 'medium' || getPasswordStrength() === 'strong'
                ? 'bg-signal-success'
                : 'bg-gray-200'
          "
        ></div>
        <!-- Medium Step -->
        <div
          class="h-2 w-10 rounded-md transition-all duration-300"
          [class]="getPasswordStrength() === 'medium' || getPasswordStrength() === 'strong' ? 'bg-signal-success' : 'bg-gray-200'"
        ></div>
        <!-- Strong Step -->
        <div
          class="h-2 w-10 rounded-md transition-all duration-300"
          [class]="getPasswordStrength() === 'strong' ? 'bg-signal-success' : 'bg-gray-200'"
        ></div>
      </div>
    }
  </div>
}
